;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .constant('INTEGRATION_CONNECTION_STATUS', {
      STANDBY: 'STAND-BY',
      INVALID: 'INVALID',
      VALID: 'VALID'
    })
    .constant('BUGTRACKER_DEFAULT_TEST_NAME', 'Default Test Connection')
})()
